import {plans} from 'constants/plans';
import useAuth from './useAuth';
import {get} from 'lodash';

export const useCompanyPlan = () => {
  const {currentUser} = useAuth();
  const planId = get(currentUser, 'company.plan.plan_id');
  const isSingleDispatch = planId === plans.SINGLE_DISPATCH;
  const isMultiDispatch = planId === plans.MULTI_DISPATCH;
  const isAiDispatch = planId === plans.AI_DISPATCH;
  return {
    isSingleDispatch,
    isMultiDispatch,
    isAiDispatch,
  };
};
